"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardService = void 0;
const core_1 = require("@angular/core");
const http_1 = require("@angular/http");
//INTERNAL BITS
const notification_service_1 = require("./notification.service");
let OnboardService = class OnboardService {
    constructor(_http, _talk) {
        this._talk = _talk;
        this.submitURL = "/obPublisherURL";
        this.http = _http;
    }
    submitApplication(publisher) {
        return this.http
            .post(this.submitURL, publisher)
            .toPromise()
            .then(result => {
            console.log(result);
            this._talk.broadcast("Your application has been submitted successfully. This window will automatically close in 5 seconds.");
        }).catch(err => {
            this._talk.broadcast("There is an issue submitting the application. Please check your form details and try again.");
            throw err;
        });
    }
};
exports.OnboardService = OnboardService;
exports.OnboardService = OnboardService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [http_1.Http,
        notification_service_1.NotificationService])
], OnboardService);
//# sourceMappingURL=onboard.service.js.map